import api from './api';

const API_URL = '/clients';

const getAllClients = async () => {
    const response = await api.get(API_URL);
    return response.data;
};

const getClientById = async (id) => {
    const response = await api.get(`${API_URL}/${id}`);
    return response.data;
};

const createClient = async (clientData) => {
    const response = await api.post(API_URL, clientData);
    return response.data;
};

const updateClient = async (id, clientData) => {
    const response = await api.put(`${API_URL}/${id}`, clientData);
    return response.data;
};

const deleteClient = async (id) => {
    await api.delete(`${API_URL}/${id}`);
};

const clientService = {
    getAllClients,
    getClientById,
    createClient,
    updateClient,
    deleteClient
};

export default clientService;
